import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import ValidateServicePopUp from "./ValidateServicePopUp";
import ValidateButton from "./ValidateButton";
import errorIcon from "@icons/ic-error.svg";
import {
  OuterDiv,
  ButtonWrapper,
  ErrorDiv,
  ErrorText,
} from "./QuoteView.styled";
import { RequiredMessage } from "@utils/extra-style";

const ValidateService = (props) => {
  const {
    t,
    hesusService,
    sellingPriceItem,
    combination,
    itemKoStatus,
    setQuoteData,
    quoteId,
    itemId,
    setIsRefeshSiteData,
  } = props;

  const [isServiceValidating, setIsServiceValidating] = useState(false);
  const [isValidate, setIsValidate] = useState(false);

  const onValidateServiceButton = (btncolor) => {
    if (btncolor === "green") setIsValidate(true);
  };

  const calculateKoAllocation = () => {
    let allocation = 0;
    sellingPriceItem?.solutions?.length > 0 &&
      sellingPriceItem?.solutions.map((priceSolution) => {
        if (
          parseInt(priceSolution?.solution.solutionStatus.id, 10) === 7 &&
          parseInt(priceSolution?.koStatus, 10) === 1
        ) {
          const calculatedAllocation = priceSolution.koAllocation
            ? priceSolution.koAllocation
            : priceSolution.allocation;
          allocation += parseInt(calculatedAllocation, 10);
        }
      });
    return parseInt(allocation, 10);
  };

  const onCancelPopUp = () => {
    setIsValidate(false);
  };

  return (
    <OuterDiv>
      {!hesusService?.needSolution && (
        <ValidateButton
          type="green"
          isServiceValidating={isServiceValidating}
          onValidateServiceButton={() => onValidateServiceButton("green")}
        />
      )}

      {hesusService?.needSolution && (
        <>
          {(calculateKoAllocation() === 100 &&
            combination &&
            ((hesusService?.needTransport &&
              !hesusService?.needProduct &&
              itemKoStatus === 1) ||
              (!hesusService?.needTransport &&
                hesusService?.needProduct &&
                itemKoStatus === 0))) ||
          (calculateKoAllocation() === 100 && !combination) ? (
            <>
              <ValidateButton
                type="green"
                isServiceValidating={isServiceValidating}
                onValidateServiceButton={() => onValidateServiceButton("green")}
              />
            </>
          ) : (
            <>
              <ButtonWrapper>
                {calculateKoAllocation() !== 100 ? (
                  <ErrorDiv marginBottom="0px">
                    <RequiredMessage>
                      <Image
                        src={errorIcon}
                        alt="warning"
                        style={{
                          height: "25px",
                          width: "25px",
                          cursor: "pointer",
                        }}
                      />{" "}
                      {t("KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_WARNING")}
                    </RequiredMessage>
                  </ErrorDiv>
                ) : (
                  <ErrorText>
                    {combination &&
                      hesusService?.needTransport &&
                      !hesusService?.needProduct &&
                      t("KICK_OFF_PAGE_QUOTE_ITEM_COMBINATED_INFO")}
                  </ErrorText>
                )}

                <ValidateButton
                  type="gray"
                  isServiceValidating={isServiceValidating}
                  onValidateServiceButton={() =>
                    onValidateServiceButton("gray")
                  }
                />
              </ButtonWrapper>
            </>
          )}
        </>
      )}

      {isValidate && (
        <ValidateServicePopUp
          onCancelPopUp={onCancelPopUp}
          hesusService={hesusService}
          combination={combination}
          sellingPriceItem={sellingPriceItem}
          isValidate={isValidate}
          setQuoteData={setQuoteData}
          quoteId={quoteId}
          itemId={itemId}
          setIsRefeshSiteData={setIsRefeshSiteData}
        />
      )}
    </OuterDiv>
  );
};

ValidateService.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ValidateService);
